<template>
  <v-card
    class="flip-card my-5"
    @click="flipCard"
    @mouseenter="startLottieAnimation"
    @mouseleave="resetLottieAnimation"
  >
    <div class="flip-card-inner" :class="{ flipped: isFlipped }">
      <div class="flip-card-front" :style="`background-image: url(${require(`../assets/${this.bgImgFront}`)})`">
        <div class="lottie-container" ref="lottieContainer"></div>
      </div>

      <div class="flip-card-back" :style="`background-image: url(${require(`../assets/${this.bgImgBack}`)})`">

      </div>
    </div>
  </v-card>
</template>

<script>
import lottie from "lottie-web";
import animationData from "@/assets/lottiefiles/click_hand.json";

export default {
  props: ["bgImgFront", "bgImgBack"],

  data() {
    return {
      isFlipped: false,
      lottieAnim: null,
    };
  },

  mounted() {
    this.renderLottieAnimation();
  },

  methods: {
    flipCard() {
      this.isFlipped = !this.isFlipped;
    },

    renderLottieAnimation() {
      const container = this.$refs.lottieContainer;

      if (container) {
        const animationOptions = {
          container: container,
          animationData: animationData,
          loop: true,
          autoplay: false,
        };

        this.lottieAnim = lottie.loadAnimation(animationOptions);
      }
    },

    startLottieAnimation() {
      if (this.lottieAnim) {
        this.lottieAnim.play();
      }
    },

    resetLottieAnimation() {
      if (this.lottieAnim) {
        this.lottieAnim.goToAndStop(0);
      }
    },
  },
};
</script>

<style scoped>
.flip-card {
  width: 800px;
  height: 470px;
  perspective: 1000px;
  border-radius: 8px;
  transition: transform 200ms ease;
  position: relative;
  background: #EA532E;
  box-shadow: none !important;
}

.flip-card:hover {
  transform: scale(1.2);
}

@media (max-width: 600px) {
  .flip-card {
    width: 100%;
    height: 300px;
  }
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.lottie-container {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  object-fit: cover;
  padding-right: 2px;
}

.flipped {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 8px;
}

.flip-card-front {
  background-position: center;
  background-size: contain;
}

.flip-card-back {
  transform: rotateY(180deg);
  background-position: center;
  background-size: contain;
}

</style>
